
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const ResourcesPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-gray-900 to-gray-800 text-white py-20">
        <div className="absolute inset-0 bg-black/50"></div>
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=modern%20library%20with%20christian%20books%20and%20digital%20resources%2C%20ministry%20training%20materials%2C%20apostolic%20teaching%20resources%2C%20spiritual%20education%20center%2C%20inspiring%20learning%20environment&width=1200&height=600&seq=resourceshero&orientation=landscape')`
          }}
        ></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Ministry Resources
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
            Access a wealth of apostolic teachings, training materials, and spiritual resources to grow in your faith and ministry
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="/join" 
              className="bg-[#b8144a] hover:bg-[#9a1139] text-white px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap"
            >
              Join PAAM for Access
            </a>
            <a 
              href="https://portal.paamorgintl.org/start" 
              className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap"
            >
              Start Training Program
            </a>
          </div>
        </div>
      </section>

      {/* Member Access Notice */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-white rounded-2xl shadow-xl p-12">
            <div className="w-20 h-20 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-lock-line text-white text-3xl"></i>
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Exclusive Member Resources
            </h2>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Our comprehensive library of apostolic teachings, training materials, books, audio series, 
              video courses, and study guides are exclusively available to PAAM family members who have 
              completed the 60-day Global Mandate Training Program.
            </p>
            <div className="bg-[#b8144a]/10 rounded-xl p-6 mb-8">
              <p className="text-lg text-gray-700 font-medium">
                "Every believer must be grounded, guided, and grown through the doctrine of Christ"
              </p>
              <p className="text-sm text-gray-600 mt-2">- Apostle Peter O. Akinnubi</p>
            </div>
            <a 
              href="/join" 
              className="bg-[#b8144a] hover:bg-[#9a1139] text-white px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap inline-block"
            >
              Begin Your Journey Today
            </a>
          </div>
        </div>
      </section>

      {/* What You'll Access */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">What You'll Access as a Member</h2>
            <p className="text-xl text-gray-600">Comprehensive resources for every aspect of ministry and spiritual growth</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-book-open-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Books &amp; Publications</h3>
              <p className="text-gray-600">Apostolic teachings, doctrinal foundations, and spiritual insights from proven ministry leaders including "From Moses to Messiah" and "In Him: A Decade of Divine Mandates".</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-headphone-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Audio Teachings</h3>
              <p className="text-gray-600">Complete conference sessions, sermons, worship music, and the full ABIC convention recordings to strengthen your faith journey.</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-video-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Video Courses</h3>
              <p className="text-gray-600">Comprehensive training programs including Apostolic Foundations, Mission Field Preparation, and specialized ministry development courses.</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-file-text-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Study Guides</h3>
              <p className="text-gray-600">Practical manuals including CFN Leadership Manual, Prayer and Intercession Toolkit, and Ecclesia Gathering Guidelines for ministry implementation.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Training Program Overview */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">The Path to Access</h2>
            <p className="text-xl text-gray-600">Complete the 60-day Global Mandate Training Program to unlock all resources</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl shadow-lg p-8 text-center">
              <div className="w-12 h-12 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4 text-white font-bold text-xl">
                1
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Register for Training</h3>
              <p className="text-gray-600 mb-4">Sign up for the free 60-day PAAM Global Mandate Training Program through our digital platform.</p>
              <a 
                href="https://portal.paamorgintl.org/start" 
                className="text-[#b8144a] hover:text-[#9a1139] font-semibold transition-colors"
              >
                Start Training →
              </a>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg p-8 text-center">
              <div className="w-12 h-12 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4 text-white font-bold text-xl">
                2
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Complete 5 Modules</h3>
              <p className="text-gray-600 mb-4">Progress through the structured training covering apostolic foundations, from Moses to Messiah, and ministry development.</p>
              <a 
                href="/join" 
                className="text-[#b8144a] hover:text-[#9a1139] font-semibold transition-colors"
              >
                Learn More →
              </a>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg p-8 text-center">
              <div className="w-12 h-12 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4 text-white font-bold text-xl">
                3
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Access All Resources</h3>
              <p className="text-gray-600 mb-4">Receive your membership certificate and gain full access to our comprehensive resource library and CFN network.</p>
              <span className="text-[#b8144a] font-semibold">Full Access Granted</span>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-[#b8144a] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Ready to Access Premium Resources?</h2>
          <p className="text-xl mb-8">
            Join thousands of believers worldwide who have completed the PAAM Global Mandate Training and gained access to life-transforming apostolic resources.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://portal.paamorgintl.org/start" 
              className="bg-white text-[#b8144a] hover:bg-gray-100 px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap"
            >
              Start Training Now
            </a>
            <a 
              href="/join" 
              className="border-2 border-white text-white hover:bg-white hover:text-[#b8144a] px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap"
            >
              Learn About PAAM
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ResourcesPage;
